// Styled components
import styled from "@emotion/styled";

export const BoardContainer = styled.div`
  margin: 2rem auto;
  max-width: 1000px;
  padding: 1rem;
  font-family: Arial, sans-serif;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
`;

export const Card = styled.div`
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  padding: 1.5rem;
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;

  &:hover {
    transform: scale(1.03);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  }
`;

export const ProfilePhoto = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 1rem;
`;

export const Name = styled.h3`
  margin: 0.5rem 0 0;
  font-size: 1.25rem;
  color: #333;
`;

export const JobTitle = styled.p`
  margin: 0.5rem 0 0;
  font-size: 1rem;
  color: #555;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #fff;
  padding: 2rem;
  border-radius: 10px;
  max-width: 500px;
  width: 90%;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
`;

export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #555;
  cursor: pointer;
  position: absolute;
  top: 1rem;
  right: 1rem;
`;